"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CONTRACT_HOURS = exports.ContractHourType = void 0;
var ContractHourType;
(function (ContractHourType) {
    ContractHourType["TEAM_HOURS"] = "team";
    ContractHourType["OPS_HOURS"] = "ops";
    ContractHourType["BANK_HOURS"] = "bank";
    ContractHourType["EM_HOURS"] = "em";
})(ContractHourType || (exports.ContractHourType = ContractHourType = {}));
exports.DEFAULT_CONTRACT_HOURS = [
    ContractHourType.TEAM_HOURS,
    ContractHourType.OPS_HOURS,
    ContractHourType.BANK_HOURS,
];
//# sourceMappingURL=ContractHoursType.js.map